import manifest from "./manifest.js";

const aliases = {
  [manifest.core.SABLIER_V2_LOCKUP_DYNAMIC]: "LD",
  [manifest.core.SABLIER_V2_LOCKUP_LINEAR]: "LL",
};

export default aliases;
